import React, { useEffect, useState } from 'react';
import { MessageCircle } from 'lucide-react';
import UserService from '../../../services/user.service';
import { toast } from 'react-toastify';
import { modalPrimaryBtn, modalSecondaryBtn } from '../../../components/ui/modalDesign';

interface SurveyProps {
    id: number | string,
    body: string,
    createdAt: string | Date,
    nText: string,
    pText: string,
    responses: any[],
    status: boolean,
    title: string,
    updatedAt: string | Date
}

interface Props {
    surveys: SurveyProps[]
}

export default function SurveySection({ surveys }: Props) {
    const userService = new UserService();
    const [initialSurveyArr, setInitialSurveyArr] = useState<SurveyProps[]>([]);
    const [arrIndex, setArrIndex] = useState(0);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (surveys.length > 0) setInitialSurveyArr(surveys);
    }, [surveys]);

    const handleSubmit = async (id: number | string, answer: boolean) => {
        setLoading(true);
        try {
            const response = await userService.answerSurvey(id, { response: answer });
            setLoading(false);
            if (!response.status) {
                toast.error(response.message);
                return;
            }
            setArrIndex((prev) => prev + 1);
        } catch {
            setLoading(false);
        }
    };

    if (arrIndex >= initialSurveyArr.length) return null;
    const survey = surveys[0];

    return (
        <div className="mb-2 rounded-[18px] border border-ryd-primary/15 bg-white p-4 shadow-[0_8px_30px_rgba(136,22,122,0.05)] sm:p-5">
            <div className="flex flex-col gap-4 lg:flex-row lg:items-center lg:justify-between">
                <div className="flex min-w-0 items-start gap-3">
                    <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-ryd-primaryLess1 text-ryd-primary">
                        <MessageCircle size={18} />
                    </div>
                    <div className="min-w-0">
                        <p className="text-[11px] font-semibold uppercase tracking-wide text-ryd-primary">{survey.title}</p>
                        <p className="mt-1 text-[14px] leading-relaxed text-[#476788]">{survey.body}</p>
                    </div>
                </div>
                {loading ? (
                    <div className="h-8 w-8 animate-spin rounded-full border border-ryd-primary border-l-transparent" />
                ) : (
                    <div className="flex w-full flex-col gap-2 sm:flex-row lg:w-auto">
                        <button type="button" className={`${modalPrimaryBtn} lg:min-w-[140px]`} onClick={() => handleSubmit(survey.id, true)}>
                            {survey.pText}
                        </button>
                        <button type="button" className={`${modalSecondaryBtn} lg:min-w-[140px]`} onClick={() => handleSubmit(survey.id, false)}>
                            {survey.nText}
                        </button>
                    </div>
                )}
            </div>
        </div>
    );
}
